export var experimentsSpecMap = {
    EXPERIMENT_CHANGE_PP_NAVIGATION: 'specs.bookings.ChangePricingPlanNavigationToNewApi',
    IS_NEW_BOOKINGS_MEMBERS_AREA_INSTALLED: 'specs.bookings.isNewBookingsMembersAreaInstalled',
};
//# sourceMappingURL=experimentsSpecMap.js.map